<mat-dialog-content xmlns="http://www.w3.org/1999/html">
  <h2>
    {{ data.title }}
    <mat-divider></mat-divider>
  </h2>
  <mat-card-content>
    <div [innerHTML]="data.text" class="dialog-text"></div>
    <div class="align-right">
      <button mat-raised-button mat-dialog-close>
        <mat-icon class="material-icons-outlined">close</mat-icon>
        <span>Close</span>
      </button>
      <button mat-raised-button color="primary" (click)="confirmDialog()">
        <mat-icon class="material-icons-outlined">done</mat-icon>
        <span>Ok</span>
      </button>
    </div>
  </mat-card-content>
</mat-dialog-content>
